import jsonp from '../../../base/base/jsonp';
let timestampIndex = 0;

/**
 * 获取视频数据
 * @param {Object} originalVideoInfo 视频id
 */
const getVideoInfo = async originalVideoInfo => {
    const { guid } = originalVideoInfo;
    const random = `f${new Date().valueOf()}${timestampIndex++}`;
    const url = `//tv.ifeng.com/h6/${guid}_${random}/getVideoById.json`;
    const videoInfo = await jsonp(url, {
        jsonpCallback: random,
        cache: false,
    });

    if (videoInfo.guid && videoInfo.guid === guid) {
        const {
            posterUrl = '',
            duration = 0,
            guid = '',
            gqSrc = '',
            CPId = '',
            title = '',
            categoryId = '',
            createdate = '',
            columnName = '',
        } = videoInfo;

        return {
            bigPosterUrl: posterUrl,
            duration,
            guid,
            playUrl: gqSrc,
            title,
            CPId,
            categoryId,
            createdate,
            columnName,
        };
    }

    const { bigPosterUrl = '', duration = 0, playUrl = '', mobileUrl = '', title = '' } = originalVideoInfo;

    return {
        guid,
        bigPosterUrl,
        duration,
        playUrl: playUrl ? playUrl : mobileUrl,
        title,
        CPId: '',
        categoryId: '',
        createdate: '',
        columnName: '',
    };
};

export default getVideoInfo;
